export default __webpack_public_path__ + "5dfca44765d0a3dedce72597c7d2382a.png";